module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "mod"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "list"
  }, [_c('img', {
    staticClass: "layer",
    attrs: {
      "src": "static/img/女神节.jpg",
      "data-src": "static/img/女神节.jpg",
      "alt": "layer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row1"
  }, [_c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": "static/img/按摩仪.png",
      "data-src": "static/img/按摩仪.png",
      "alt": "largeIcon"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.receive1 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1 icon"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(1)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive1 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey1 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row2"
  }, [_c('img', {
    staticClass: "largeIcon_2",
    attrs: {
      "src": "static/img/保温杯.png",
      "data-src": "static/img/保温杯.png",
      "alt": "largeIcon_2"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.receive2 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(2)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive2 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey2 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row3"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.receive3 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(3)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive3 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey3 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row4"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.receive4 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(4)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive4 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey4 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "group_6"
  }, [_c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("\n              返回首页\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_2"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("PGG")]), _vm._v(" "), _c('span', {
    staticClass: "txt"
  }, [_vm._v("颈椎按摩器")])]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("礼品将在回款后为您寄出")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_2"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("特美刻")]), _vm._v(" "), _c('span', {
    staticClass: "txt"
  }, [_vm._v("智能保温杯")])]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("礼品将在回款后为您寄出")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_3"
  }, [_c('img', {
    staticClass: "largeIcon_3",
    attrs: {
      "src": "static/img/台灯.png",
      "data-src": "static/img/台灯.png",
      "alt": "largeIcon_3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "group_4"
  }, [_c('span', {
    staticClass: "txt_2"
  }, [_vm._v("华为智选")]), _vm._v(" "), _c('span', {
    staticClass: "word_3"
  }, [_vm._v("智能台灯")])]), _vm._v(" "), _c('span', {
    staticClass: "desc_3"
  }, [_vm._v("礼品将在回款后为您寄出")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block_6"
  }, [_c('img', {
    staticClass: "largeIcon_4",
    attrs: {
      "src": "static/img/三只松鼠.png",
      "data-src": "static/img/三只松鼠.png",
      "alt": "largeIcon_4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_4"
  }, [_c('div', {
    staticClass: "group_4"
  }, [_c('span', {
    staticClass: "txt_2"
  }, [_vm._v("三只松鼠")]), _vm._v(" "), _c('span', {
    staticClass: "word_3"
  }, [_vm._v("坚果礼包")])]), _vm._v(" "), _c('span', {
    staticClass: "desc_3"
  }, [_vm._v("礼品将在回款后为您寄出")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("活动说明")]), _vm._v(" "), _c('span', {
    staticClass: "article"
  }, [_vm._v("\n            1、下单成功后可进行礼品选择，每个账户限参与一次，礼品将在订单回款后5个工作日后安排寄送；"), _c('br'), _vm._v("\n            2、扩增合同，血清和冰盒产品不参与本次活动，其他产品都参加；"), _c('br'), _vm._v("\n            3、该折扣优惠与其他优惠券和会员折扣不同享。\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f683660e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/Order/SuccessPay4.vue
// module id = 1738
// module chunks = 8